var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doc-versoes"},[_vm._v(" Não disponível no momento. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }